<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">{{ crud }} Categoria</h4>
      </div>
      <div>
        <fg-input
          name="name"
          label="Nome"
        >
          <el-input
            type="text"
            placeholder="Nome"
            v-model="model.name"
            maxlength="199"
            show-word-limit='true'
          ></el-input>
          <span style="font-size: 0.7rem; display: flex;  justify-content: flex-end;">
            Caracteres: {{model.name.length}}/199</span>
        </fg-input>
        <fg-input v-if="showMatriz" name="company" label="Empresa">
          <el-select
            class
            size="large"
            style="width: 100%"
            placeholder="Selecione a empresa dos usuários"
            v-model="model.company"
          >
            <el-option
              v-for="option in companyList"
              class
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input>

        <fg-input label="Descrição">
          <textarea
            class="form-control"
            v-model="model.description"
            maxlength="300"
            placeholder="Escreva aqui..."
            rows="3"
          ></textarea>
          <span style="font-size: 0.7rem; display: flex;  justify-content: flex-end;">
            Caracteres: {{model.description.length}}/300</span>
        </fg-input>
        <fg-input
          name="position"
          label="Alterar posição - deixar vazio para comportamento normal"
          v-validate="modelValidations.position"
          type="number"
          v-model="model.position"
          :error="getError('position')"
        ></fg-input>
      </div>
    </card>
    <!-- <card v-if="showImage && showCatImag" class="col-sm-12">
      <div>
        <label>Imagem</label>
      </div>
      <div class="img-upload">
      <div class="col-sm-12 row" style="margin-bottom: 50px" v-if="imagesAPI.length > 0 || images.length > 0">
          <img :src="images[0].image" alt="Imagem categoria" style="padding: 15px" height="100%">
          <l-button @click.prevent="delImage()" v-if="imagesAPI.length > 0" round class="btn-danger btn col-sm-1 offset-sm-5">
            <i class="fa fa-times"></i>
          </l-button>
          <l-button @click.prevent="removeImage()" v-if="imagesAPI.length < 1" round class="btn-danger btn col-sm-1 offset-sm-5">
            <i class="fa fa-times"></i>
          </l-button>
        </div>
        <div class="col-sm-12">
          <l-button
            v-if="images.length > 0"
            size="sm"
            class="btn btn-social btn-round btn-outline btn-info"
            @click="$refs.SelectImage.click()"
          >Trocar imagem</l-button>
          <l-button
            v-if="images.length < 1"
            size="sm"
            class="btn btn-social btn-round btn-outline btn-info"
            @click="$refs.SelectImage.click()"
          >Nova imagem</l-button>
          <input
            name="image"
            style="display: none"
            label="Image"
            type="file"
            ref="SelectImage"
            accept="image/*"
            @change="onChange"
            class="col-sm-12"
          >
        </div>
      </div>
    </card> -->
    <card>
      <div>
        <el-button type="primary" :loading="btnLoading" 
          @click.prevent="validate">Salvar</el-button>
        <!-- <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Salvar</button> -->
      </div>
    </card>
    <card v-if="tableData.length > 0">
      <h3>Produtos da categoria</h3>
      <div class="table-responsive table-full-width">
        <el-table class="table-striped" :data="tableData">
          <el-table-column label="SKU" property="sku" width="180"></el-table-column>
          <el-table-column label="Nome" property="name" min-width="340"></el-table-column>
          <el-table-column label="Limite de Venda" property="limit" width="150"></el-table-column>
        </el-table>
      </div>
    </card>
  </form>
</template>
<script>
import { Table, TableColumn, Button, Upload, Select, Option } from "element-ui";
import swal from "sweetalert2";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select,
    [Button.name]: Button,
    [Upload.name]: Upload,
  },
  mounted() {
    var ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) {
      this.model.company = ciaID
    } else {
      ciaID = ''
    }
    this.getListCompany()
    if (this.$route.params.id) {
      this.$store.dispatch("categories/listSort", {sort: '?company=' + ciaID}).then(() => {
        console.log(this.$store.state.categories.categories);
        this.model = this.$store.state.categories.categories.find(
          e => e.id == this.$route.params.id
        );
        this.$store.dispatch("categories/images/listSort", {sort: '?category=' + this.$route.params.id}).then(resp => {
          this.imagesAPI = this.$store.state.categories.images.images
          this.images = this.$store.state.categories.images.images
          
        });
      });
      this.crud = "Editar";
    } else {
      this.crud = "Criar";
    }
    this.featureFlag()
  },
  computed: {
    categories() {
      return this.$store.state.categories.categories;
    },
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
    showItem() {
      const smartmach = localStorage.getItem("smartmach");
      if (smartmach === "true") {
        return true;
      } else {
        return false;
      }
    },
    tableData() {
      const products = this.$store.state.products.products.filter(
        e => e.category == this.$route.params.id
      );
      const populated = products.map(v => {
        let category;
        if (v.category) {
          category = this.categories.find(e => e.id == v.category);
        }
        return { ...v, category };
      });
      return populated;
    }
  },
  data() {
    return {
      crud: "Editar",
      imagesAPI: [],
      images: [],
      companyList:[],
      showCatImag: false,
      btnLoading: false,
      showImage: true,
      // imageKey: 0,
      model: {
        name: "",
        description: ""
        // image: null
      },
      products: [],
      modelValidations: {
        name: {
          required: true
        }
      }
    };
  },
  methods: {
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getListCompany () {
      this.$store.dispatch("company/list").then(resp => {
        this.companyList = resp.sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0)
    
      })
    },
    onChange(event) {
      this.images = []
      for (let i of event.target.files) {
        const reader = new FileReader();
        reader.onload = e => {
          const image = e.target.result;
          const title = i.name;
          const category = this.$route.params.id
          this.images.push({ title, image, category });
        };
        console.log("i", i);
        this.hasImage = true;
        reader.readAsDataURL(i);
      }
    },
    imageUpload(category) {
      if (this.images.length !== 0 || this.imagesAPI.length !== 0) {
        if (!this.images[0].id) {
          if (this.imagesAPI.length > 0){
            this.images[0].id =  this.imagesAPI[0].id
            this.images[0].category = category
            this.$store
              .dispatch("categories/images/update", { item: this.images[0] })
              .then(rep => {});

          } else {
            this.images[0].category = category
            this.$store
              .dispatch("categories/images/create", { item: this.images[0] })
              .then(rep => {});
          }
        }
      }
    },
    refreshImage () {
      this.$store.dispatch("categories/images/listSort", {sort: '?category=' + this.$route.params.id}).then(resp => {
        this.imagesAPI = this.$store.state.categories.images.images
        this.images = this.$store.state.categories.images.images
        this.showImage = true
      });
    },
    removeImage () {
      this.images.splice(0,1)
    },
    delImage (id) {
      id = this.images[0].id
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse(a) imagem.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("categories/images/delete", { id }).then(resp => {
            setTimeout(() => {
              this.refreshImage();
            }, 700);
            this.showImage = false;
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não excluído(a).`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        this.btnLoading = true
        if (isValid && this.crud === "Criar") {
          this.$store
            .dispatch("categories/create", { item: this.model })
            .then(data => {
              console.log('data resp', data)
              this.notifySuccess();
              this.imageUpload(data.id)
              this.btnLoading = false
              this.$router.push(`/app/products/categories`);
            }).catch(err => {console.log(err)
            this.btnLoading = false});
        } else if (isValid && this.crud === "Editar") {
          this.$store
            .dispatch("categories/update", { item: this.model })
            .then(() => {
              this.notifySuccess();
              this.imageUpload(this.$route.params.id)
              this.btnLoading = false
              this.$router.push(`/app/products/categories`);
            }).catch(err => {console.log(err)
            this.btnLoading = false});
        }
      });
    },
    featureFlag () {
      if (this.$store.state.auth.company === "null") {
        this.showCatImag = true
      }
      var y = this.$store.state.general.flag.filter(el => {
        if (el.feature === "C02"){
          if (el.active === true) {
            this.showCatImag = true
          }
        }
      })
    },
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
